import React from 'react'
import Layout from '../DashboardLayout'

const TransmitDashboard = () => {
  return (
    <Layout>TransmitDashboard</Layout>
  )
}

export default TransmitDashboard